module.exports = __webpack_public_path__ + "img/waves-4.49a9773c.webp";